import type { IframePoolOrderItem } from '../api';

/**
 * Free-demo data source for the reveal flow. Handed to `PackReveal` (and
 * through it to the machine and the winner screen) it flips the whole flow
 * to demo: the ceremony — ready step, the operator's opening mechanic,
 * sound, rays, glow, badge sequence, the Open Next Pack loop — runs the
 * exact same code, and only the card's origin and the forward CTA change.
 *
 * Everything that costs money or speaks to the casino host is off while
 * this is set: no create/purchase/mark_as_opened/sell, no balance gate or
 * top-up, and no `gameEvents` for a round that never happened.
 */
export interface DemoRevealSource {
  /** One free card from the pack's own pool. Replaces `mark_as_opened` on
   *  the first pull and the buy+open sequence inside the loop. Rejects with
   *  a player-facing message — the machine toasts it like any open failure. */
  pullCard: () => Promise<IframePoolOrderItem>;
  /** Forward CTA copy on the winner screen ("Try Again"). */
  ctaLabel: string;
}

/**
 * Stand-in for the order id the real flow carries. Nothing reaches the
 * backend with it: every call that would use an order id is gated off in
 * demo mode, and it exists only to satisfy the shared prop shapes.
 */
export const DEMO_ORDER_ID = 'demo';
